import PropTypes from 'prop-types';

export const TopicShape = PropTypes.shape({
    /**
     * Topic Name
     */
    label: PropTypes.string,
    /**
     * Topic Url
     */
    url: PropTypes.string,
});
